import axios, { AxiosError } from 'axios';
import { Environment } from '../../../environment';
import { v4 as uuidv4 } from 'uuid';
import { Api } from '../axiosApi';

export interface IListagem {
  idlan: string;
  entrada: string;
  saida: string;
  datalan: Date;
  numero: string;
  valor: number;
  historico: string;
}
export interface Ilancamento {
  identrada: string;
  idsaida: string;
  datalan: Date;
  numero: string;
  valor: number;
  historico: string;
}
type TotalCount = {
    data: IListagem[];
    totalCount: number;
}
interface ErrorResponse {
  errors: {
    default: string;
  };
}
const create = async (dados: Ilancamento): Promise<string | Error> => {
  try {
    const guuid = uuidv4();
    const { data} = await Api.post<IListagem>('/lanentrecontas',  {idlan: guuid, ...dados});
    if (Object.keys(data).length === 0) {
      return guuid;
    }
    return new Error('Erro ao criar o registro.');
  }  catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getAll = async (page = 1, datainicial = '', datafinal=''): Promise<TotalCount | Error> => {
  try {
    const urlRelativa = `/lanentrecontas?page=${page}&limit=${Environment.LIMITE_DE_LINHAS}&datainicial=${datainicial}&datafinal=${datafinal}`;
    const { data, headers } = await Api.get(urlRelativa); 
    if (data) {
      return {
        data,
        totalCount: Number(headers['x-total-count'] || Environment.LIMITE_DE_LINHAS),
      };
    }
    return new Error('Erro ao listar os registros.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const deleteById = async (id: string): Promise<void | Error> => {
  try {
    await Api.delete(`/lanentrecontas/${id}`);
  }catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
const getById = async (id: string): Promise<Ilancamento | Error> => {
  try {
    const { data } = await Api.get(`/lanentrecontas/${id}`);
    if (data) {
      return data;
    }
    return new Error('Erro ao consultar o registro.');
  } catch (error) {
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<ErrorResponse>;
      if (axiosError.response) {
        const errorMessage = axiosError.response.data.errors?.default || 'Erro desconhecido';
        return new Error(errorMessage);
      } else if (axiosError.request) {
        return new Error('Nenhuma resposta do servidor');
      } else {
        return new Error(axiosError.message);
      }
    } else {
      return new Error('Erro inesperado');
    }
  }
};
export const LancamentoEntreConstasService = {  
  getAll,
  create,
  deleteById,
  getById,
}; 